import { useMutation } from '@tanstack/react-query'

import { createCommentTemplates } from '@src/api'
import { useAxios } from '@src/hooks'

import { MutationMemoTemplateArgs } from './type'

export const useCreateCommentTemplates = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: ({ organizationId, params }: MutationMemoTemplateArgs) =>
      createCommentTemplates(axiosInstance, organizationId, params),
  })
}
